var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
        'app-btn',
        { 'border-none': !_vm.borderOnly },
        { 'border-only': _vm.borderOnly },
        { 'my-3 mt-4': !_vm.noMargin },
        { disabled: _vm.disabled },
        { condensed: _vm.condensed },
        _vm.variant ? `btn-${_vm.variant}` : 'btn-primary',
    ],attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }